<script>
import { ref, onMounted, reactive, watch } from "vue";
import Logo from "./components/Logo.vue";
import NavsButton from "./components/NavsButton.vue";
import LoadingFrame from "./components/LoadingFrame.vue";
import Indicator from "./components/Indicator.vue";
import Footer from "./components/Footer.vue";
import FirstCut from "./components/FirstCut.vue";
import SecondCut from "./components/SecondCut.vue";
import ThirdCut from "./components/ThirdCut.vue";
import FourthCut from "./components/FourthCut.vue";
import FifthCut from "./components/FifthCut.vue";
import SixthCut from "./components/SixthCut.vue";
import SeventhCut from "./components/SeventhCut.vue";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
export default {
	components: {
		Logo,
		NavsButton,
		LoadingFrame,
		Indicator,
		FirstCut,
		SecondCut,
		ThirdCut,
		FourthCut,
		FifthCut,
		SixthCut,
		SeventhCut,
		Footer,
	},
	setup() {
		const scrollTop = ref(0);
		const windowWidth = ref(window.innerWidth);
		const windowHeight = ref(window.innerHeight);
		const videoReady = ref(false);
		const isShow = ref(false);
		const isOpen = ref(false);
		const isTesting = ref(process.env.VUE_APP_YAHOO_PROJECTID === "12345");

		const imgSrc = reactive({
			pc: "site_cover.png",
			mobile: "site_cover_mobile.png",
		});

		const text = reactive({
			title: [
				"Air Breather 車側導流氣孔",
				"霧黑運動化側裙",
				"平整化車門把手",
				"掀背式電動尾門",
				"iDrive 7.0 全數位虛擬座艙",
				"寬敞車室空間",
				"Personal Copilot 智慧駕駛輔助科技",
				"BMW 智慧語音助理 2.0",
			],
			content: [
				"黑色高光澤造型飾條設計，提升空氣力學效果。",
				"強化跑格氣息，彰顯前後輪拱俐落線條。",
				"新世代設計語彙，有助空氣力學表現。",
				"腳踢感應即可啟閉尾門，高達470公升寬敞空間，<br />取放皆便利。",
				"12.3 吋虛擬數位儀錶 / 10.25 吋中控觸控螢幕 /<br />iDrive 7.0 使用者介面，提供開闊且直覺的操控介面。",
				"不但有五個正常尺寸座位，藉由 40/20/40 分離可傾倒後座椅背，還能創造出高達 1,290 公升、令人印象深刻的行李廂空間。",
				"搭載主動車距定速控制系統、道路虛擬實境顯示等功能，藉儀錶內動態 3D 畫面，提供駕駛與乘客全方位安全防護，同享智能駕馭樂趣。",
				"採用最新自然語言辨識 (NLU) 科技，能聽懂更多口語化指令，讓座駕直接變身你的個人助理。<br class='pc_break' />隨時說出「你好，BMW」或是設定自己專屬的喚醒詞，讓愛車隨時與你的想法同步。",
			],
			chapter: ["EXTERIOR", "TECHNOLOGY"],
			mask: [
				{
					pc: require("@/assets/launchImg/background_c3-1_mask.jpg"),
					mobile: require("@/assets/launchImg/background_c3-1_mask_mobile.jpg"),
				},
				{
					pc: require("@/assets/launchImg/background_c3-2_mask.jpg"),
					mobile: require("@/assets/launchImg/background_c3-1_mask_mobile.jpg"),
				},
				{
					pc: require("@/assets/launchImg/background_c4-1_mask.jpg"),
					mobile: require("@/assets/launchImg/background_c4-1_mask_mobile.jpg"),
				},
				{
					pc: require("@/assets/launchImg/background_c4-2_mask.jpg"),
					mobile: require("@/assets/launchImg/background_c4-1_mask_mobile.jpg"),
				},
			],
			bg: [
				{
					pc: require("@/assets/launchImg/background_c3-1-1.png"),
					mobile: require("@/assets/launchImg/background_c3-1-1_mobile.png"),
					alt:
						"G26全新BMW 4系列Gran Coupé豪華四門跑車Air Breather 車側導流氣孔",
				},
				{
					pc: require("@/assets/launchImg/background_c3-1-2.png"),
					mobile: require("@/assets/launchImg/background_c3-1-2_mobile.jpeg"),
					alt: "G26全新BMW 4系列Gran Coupé豪華四門跑車霧黑運動化側裙",
				},
				{
					pc: require("@/assets/launchImg/background_c3-2-1.jpg"),
					mobile: require("@/assets/launchImg/background_c3-2-1_mobile.jpg"),
					alt: "G26全新BMW 4系列Gran Coupé豪華四門跑車平整化車門把手",
				},
				{
					pc: require("@/assets/launchImg/background_c3-2-2.jpg"),
					mobile: require("@/assets/launchImg/background_c3-2-2_mobile.jpg"),
					alt: "G26全新BMW 4系列Gran Coupé豪華四門跑車掀背式電動尾門",
				},
				{
					pc: require("@/assets/launchImg/background_c4-1-1.jpg"),
					mobile: require("@/assets/launchImg/background_c4-1-1_mobile.jpg"),
					alt:
						"G26全新BMW 4系列Gran Coupé豪華四門跑車 iDrive 7.0全數位虛擬座艙 虛擬數位儀表 觸控螢幕",
				},
				{
					pc: require("@/assets/launchImg/background_c4-1-2.jpg"),
					mobile: require("@/assets/launchImg/background_c4-1-2_mobile.jpg"),
					alt:
						"G26全新BMW 4系列Gran Coupé豪華四門跑車寬敞車室空間 可傾倒後座椅背 ",
				},
				{
					pc: require("@/assets/launchImg/background_c4-2-1.jpg"),
					mobile: require("@/assets/launchImg/background_c4-2-1_mobile.jpg"),
					alt:
						"G26全新BMW 4系列Gran Coupé豪華四門跑車 Personal CoPilot智慧駕駛輔助 科技道路虛擬實境顯示 主動車距定速控制系統",
				},
				{
					pc: require("@/assets/launchImg/background_c4-2-2.jpg"),
					mobile: require("@/assets/launchImg/background_c4-2-2_mobile.jpg"),
					alt:
						"G26全新BMW 4系列Gran Coupé豪華四門跑車  BMW智慧語音助理2.0 ",
				},
			],
		});
		const nowFeature = ref(0);
		const featuresDisplay = (instruction) => {
			if (nowFeature.value >= 4) {
				if (instruction === "next") {
					if (nowFeature.value >= 7) {
						nowFeature.value = 4;
					} else {
						nowFeature.value++;
					}
				} else {
					if (nowFeature.value <= 4) {
						nowFeature.value = 7;
					} else {
						nowFeature.value--;
					}
				}
			} else {
				if (instruction === "next") {
					if (nowFeature.value >= 3) {
						nowFeature.value = 0;
					} else {
						nowFeature.value++;
					}
				} else {
					if (nowFeature.value <= 0) {
						nowFeature.value = 3;
					} else {
						nowFeature.value--;
					}
				}
			}
		};

		const xDown = ref(null);
		const yDown = ref(null);

		const getTouches = (evt) => {
			return evt.touches || evt.originalEvent.touches;
		};

		const handleTouchStart = (evt) => {
			const firstTouch = getTouches(evt)[0];
			xDown.value = firstTouch.clientX;
			yDown.value = firstTouch.clientY;
		};

		const handleTouchMove = (evt) => {
			if (!xDown.value || !yDown.value) {
				return;
			}

			const xUp = evt.touches[0].clientX;
			const yUp = evt.touches[0].clientY;

			const xDiff = xDown.value - xUp;
			const yDiff = yDown.value - yUp;

			if (Math.abs(xDiff) > Math.abs(yDiff)) {
				/*most significant*/
				if (xDiff > 0) {
					featuresDisplay("next");
				} else {
					featuresDisplay("previous");
				}
			}
			/* reset values */
			xDown.value = null;
			yDown.value = null;
		};

		const handleChangeState = (val) => {
			videoReady.value = val;
		};
		const handleChangeIsShow = (val) => {
			isShow.value = val;
		};

		const handleChangeContentStatus = (val) => {
			isOpen.value = val;
		};
		const handleChangeShowIndex = (val) => {
			nowFeature.value = val;
		};

		const contentClose = () => {
			isOpen.value = false;
		};

		gsap.registerPlugin(ScrollToPlugin);
		const goAnchor = (id, e) => {
			e.preventDefault();
			gsap.to(document.body, {
				scrollTo: {
					y: id,
					offsetY:
						id === "#performance" ? -windowHeight.value - 75 : 0,
					autoKill: true,
				},
				ease: "power2.inOut",
				duration: 1.5,
			});
		};

		onMounted(() => {
			window.addEventListener("resize", () => {
				windowWidth.value = window.innerWidth;
				windowHeight.value = window.innerHeight;
			});
			document.body.addEventListener("scroll", (e) => {
				scrollTop.value = e.target.scrollTop;
			});
			document.body.addEventListener("resize", (e) => {
				scrollTop.value = e.target.scrollTop;
			});
		});

		watch(windowHeight, (nv, ov) => {
			scrollTop.value = document.body.scrollTop;
		});

		return {
			windowWidth,
			windowHeight,
			scrollTop,
			videoReady,
			handleChangeState,
			isShow,
			handleChangeIsShow,
			goAnchor,
			imgSrc,
			handleChangeContentStatus,
			handleChangeShowIndex,
			isOpen,
			contentClose,
			text,
			nowFeature,
			featuresDisplay,
			handleTouchStart,
			handleTouchMove,
			isTesting,
		};
	},
};
</script>

<template>
	<!-- <p
		v-if="isTesting"
		style="font-size: 1rem; position: fixed; top: 0; left: 0; z-index: 1000"
		>{{ `${windowWidth} ${windowHeight}` }}</p
	> -->
	<Logo />
	<LoadingFrame @changeState="handleChangeState" />
	<NavsButton
		:windowWidth="windowWidth"
		:windowHeight="windowHeight"
		:scrollTop="scrollTop"
		@changeIsShow="handleChangeIsShow"
	/>
	<main>
		<FirstCut
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
			:videoReady="videoReady"
		/>
		<SecondCut
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
		/>
		<ThirdCut
			@changeContentStatus="handleChangeContentStatus"
			@changeShowIndex="handleChangeShowIndex"
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
			:nowFeature="nowFeature"
			:isOpen="isOpen"
		/>
		<FourthCut
			@changeContentStatus="handleChangeContentStatus"
			@changeShowIndex="handleChangeShowIndex"
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
			:nowFeature="nowFeature"
			:isOpen="isOpen"
		/>
		<FifthCut
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
		/>
		<SixthCut
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
		/>

		<SeventhCut
			:windowWidth="windowWidth"
			:windowHeight="windowHeight"
			:scrollTop="scrollTop"
		/>
		<div class="site-sticky">
			<div class="sticky-wrapper">
				<img
					class="site-cover"
					:src="
						require(`@/assets/${
							windowWidth > 768 ? imgSrc.pc : imgSrc.mobile
						}`)
					"
				/>
				<div class="goto-button" v-show="!isShow">
					<a
						class="gotoForm-button"
						href="#form"
						@click="goAnchor('#form', $event)"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'sidenavi',
							event_label: 'testdrive',
						}"
					>
						<div class="border top"></div>
						<div class="border right"></div>
						<div class="border bottom"></div>
					</a>
					<a
						class="gotoEquipment-button"
						href="equipment/THE-4-gran-coupe-technical-data.pdf"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'sidenavi',
							event_label: 'technical_data',
						}"
					>
						<div class="border top"></div>
						<div class="border right"></div>
						<div class="border bottom"></div>
					</a>
				</div>
			</div>
		</div>
	</main>
	<Indicator
		:windowHeight="windowHeight"
		:scrollTop="scrollTop"
		:videoReady="videoReady"
	/>
	<Footer />
	<div class="apiLoadingFrame"></div>
	<div class="loading-indicator">
		<div class="loading-ring">
			<div class="inner-ring"></div>
		</div>
		<div class="t-ring">
			<div class="bar bar1"></div>
			<div class="bar bar2"></div>
			<div class="bar bar3"></div>
			<div class="bar bar4"></div>
			<div class="bar bar5"></div>
		</div>
	</div>
	<transition name="fade">
		<div class="content" v-show="isOpen">
			<div
				class="content-body"
				@touchstart="handleTouchStart"
				@touchmove="handleTouchMove"
			>
				<div class="content-btn" @click="contentClose">
					<div class="longbar"></div>
					<div class="shortbar"></div>
				</div>
				<div class="content-title">
					<p
						v-for="(item, idx) in text.title"
						:key="item"
						:style="{ opacity: nowFeature === idx ? 1 : 0 }"
						><span>{{ item }}</span></p
					>
				</div>
				<div class="content-text">
					<p
						v-for="(item, idx) in text.content"
						:key="item"
						:style="{ opacity: nowFeature === idx ? 1 : 0 }"
						><span v-html="item"></span
					></p>
				</div>
				<div class="content-switcher">
					<div
						class="switcher_left"
						@click="featuresDisplay('previous')"
					></div>
					<div
						class="switcher_right"
						@click="featuresDisplay('next')"
					></div>
				</div>
				<div class="content-indicator text_en_thin">
					<p
						v-for="(item, idx) in text.chapter"
						:key="item"
						:style="{
							opacity: parseInt(nowFeature / 4) === idx ? 1 : 0,
							left: idx === 0 ? '50%' : 'auto',
						}"
						>{{ item }}
						<span
							v-for="item in 4"
							:key="item"
							:style="{
								opacity:
									nowFeature - idx * 4 + 1 === item ? 1 : 0,
							}"
							>0{{ item }}</span
						></p
					>
				</div>
			</div>
			<div
				class="content-bg"
				@touchstart="handleTouchStart"
				@touchmove="handleTouchMove"
			>
				<transition
					v-for="(item, idx) in text.bg"
					:key="item"
					name="bg-switch"
				>
					<img
						v-show="nowFeature === idx"
						:src="windowWidth > 992 ? item.pc : item.mobile"
						:alt="item.alt"
					/>
				</transition>
			</div>
			<div class="content-mask">
				<transition
					v-for="(item, idx) in text.mask"
					:key="item"
					name="mask-switch"
				>
					<img
						v-show="parseInt(nowFeature / 2) === idx"
						:src="windowWidth > 992 ? item.pc : item.mobile"
						alt=""
					/>
				</transition>
			</div>
		</div>
	</transition>
</template>

<style lang="scss">
$bfHeight: 50vh;

$bfHeight2: 30vh;
$rwdHeight1: 80vh;
$rwdHeight2: 70vh;
$rwdHeight3: 130vh;

$ratio1: 100vh / (2100vh + 8 * $bfHeight);
$ratio2: 100vh / (2100vh + 8 * $bfHeight + $rwdHeight1);
$ratio3: 100vh / (2100vh + 8 * $bfHeight + $rwdHeight2);
$ratio4: 100vh / (2100vh + 8 * $bfHeight + $rwdHeight3);

$mainH1: 2100vh + 8 * $bfHeight;
$mainH2: 2100vh + 8 * $bfHeight + $rwdHeight1;
$mainH3: 2100vh + 8 * $bfHeight + $rwdHeight2;
$mainH4: 2100vh + 8 * $bfHeight + $rwdHeight3;

$ssH: 100vh;

$storyH: 200vh + $bfHeight;

$titleH: 100vh + $bfHeight;
$titleT: -100vh - $bfHeight;

$descH: 300vh + $bfHeight;
$descT: -200vh - $bfHeight;

$desctH: 100vh + $bfHeight;
$desctT: -300vh - 2 * $bfHeight;

$exteH: 550vh + $bfHeight;
$exteT: -400vh - 2 * $bfHeight;

$extetH: 350vh + $bfHeight;
$extetT: -750vh - 3 * $bfHeight;

$techH: 400vh + $bfHeight;
$techT: -750vh - 3 * $bfHeight;

$techtH: 300vh + $bfHeight;
$techtT: -1050vh - 4 * $bfHeight;

$perfH: 350vh + $bfHeight;
$perfT: -1150vh - 4 * $bfHeight;

$perftH: 150vh + $bfHeight;
$perftT: -1300vh - 5 * $bfHeight;

$concepH: 300vh + $bfHeight;
$concepT: -1400vh - 5 * $bfHeight;

$conceptH: 100vh + $bfHeight;
$conceptT: -1500vh - 6 * $bfHeight;

$imgnH: 300vh + $bfHeight;
$imgnT: -1600vh - 6 * $bfHeight;

$imgntH: 100vh + $bfHeight;
$imgntT: -1700vh - 7 * $bfHeight;

$displayH1: 200vh + $bfHeight;
$displayH2: 200vh + $bfHeight + $rwdHeight1;
$displayH3: 200vh + $bfHeight + $rwdHeight2;
$displayH4: 200vh + $bfHeight + $rwdHeight3;
$seridispH: 150vh;
$displayT: -1700vh - 7 * $bfHeight;

$time1: 2.5s;
$time2: 0.8s;

* {
	color: #fff;
	font-size: 0px;
}

h1,
h2,
p {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 0;
	font-weight: normal;
	vertical-align: baseline;
}

html,
body {
	height: 100%;
	margin: 0px;
	padding: 0px;
	font-size: 10px;
	background-color: #111;
	overflow-x: hidden;
}

body {
	height: 100%;
	// height: $mainH1 * 1% / 1vh;
	overflow-y: scroll;
}

section {
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 500px;
}

.sticky-wrapper {
	position: -webkit-sticky;
	position: sticky;
	top: 0px;
}

.text_en_bold {
	font-family: "BMWTypeNextLatinTT-Bold", serif;
	letter-spacing: 1.13px;
}
.text_en_regular {
	font-family: "BMWTypeNextLatinTT-Regular", serif;
}
.text_en_light {
	font-family: "BMWTypeNextLatinTT-Light", serif;
}
.text_en_thin {
	font-family: "BMWTypeNextLatinTT-Thin", serif;
}
.text_ch_heavy {
	font-family: arudjingxiheipe1xg30_hv, 微軟正黑體;
}
.text_ch_medium {
	font-family: arudjingxiheipe1xg30_md, 微軟正黑體;
}

.shine {
	background: linear-gradient(
		90deg,
		#707070 0%,
		rgba(255, 255, 255, 0.5) 12%,
		rgba(255, 255, 255, 1) 24%,
		#707070 36%
	);
	// background-size: cover;
	background-position: 0 10px;
	background-clip: text; // is needed?
	-webkit-background-clip: text;
	background-repeat: repeat-x;
	-webkit-text-fill-color: transparent;
	animation: shine 4s infinite linear forwards;
	z-index: 100;
}
.shake {
	animation: shake 1.5s infinite ease forwards;
}
.hshake_right {
	animation: hShake_right 1.5s infinite ease forwards;
}
.hshake_right_sm {
	animation: hShake_right_sm 1.8s infinite ease forwards;
}
.hshake_left {
	animation: hShake_left 1.5s infinite ease forwards;
}

#app {
	position: relative;
	width: 100%;
	height: 100%;
	top: -15px;
	main {
		position: relative;
		height: $mainH1 * 1% / 1vh;
		// height: 100%;
		// height: 1000vh;
		.site-sticky {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0%;
			z-index: 65;
			.sticky-wrapper {
				height: $ssH * $ratio1 * 1% / 1vh;
				top: 0;
				img {
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: 100%;
					pointer-events: none;
				}
				.goto-button {
					position: absolute;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
					z-index: 200;
					background-color: transparent;
					.gotoForm-button,
					.gotoEquipment-button {
						position: relative;
						width: 36px;
						height: 176px;
						margin: 6px 0;
						// background-image: linear-gradient(
						// 	to right,
						// 	rgba(255, 255, 255, 0.2) 1%,
						// 	rgba(102, 102, 102, 0.3) 99%
						// );
						// text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
						// font-family: arudjingxiheipe1xg30_hv;
						// font-size: 1.5rem;
						// line-height: 36px;
						// letter-spacing: 10px;
						// text-align: center;
						// -webkit-writing-mode: vertical-rl;
						// writing-mode: vertical-lr;
						// text-decoration: none;
						background-position: center;
						background-repeat: no-repeat;
						box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.25);
						.border {
							position: absolute;
							width: 36px;
							height: 1px;
							opacity: 0.5;
							background-image: linear-gradient(
								to right,
								#fff 2%,
								rgba(255, 255, 255, 0) 98%
							);
							&.top {
								left: 0;
								top: 0;
							}
							&.bottom {
								left: 0;
								bottom: 0;
							}
							&.right {
								width: 1px;
								height: 176px;
								left: 0;
								background: none;
								background-color: rgba(#fff, 1);
							}
						}
					}
					.gotoForm-button {
						background-image: url("~@/assets/menu_button1.svg");
					}
					.gotoEquipment-button {
						background-image: url("~@/assets/menu_button2.svg");
					}
				}
			}
		}
		#story {
			height: $storyH * $ratio1 * 1% / 1vh;
			// height: 250vh;
			.sticky-wrapper {
				height: 100vh * 100% / $storyH;
				// height: 100vh;
			}
		}
		#title {
			height: $titleH * $ratio1 * 1% / 1vh;
			top: $titleT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -150vh;
			.sticky-wrapper {
				height: 100vh * 100% / $titleH;
				// height: 100vh;
			}
		}
		#description {
			height: $descH * $ratio1 * 1% / 1vh;
			top: $descT * $ratio1 * 1% / 1vh;
			// height: 350vh;
			// top: -250vh;
			.bg_c2 {
				height: 100vh * 100% / $descH;
				// height: 100vh;
			}
		}
		#description-text {
			height: $desctH * $ratio1 * 1% / 1vh;
			top: $desctT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -400vh;
			.sticky-wrapper {
				height: 100vh * 100% / $desctH;
				// height: 100vh;
			}
		}
		#exterior {
			height: $exteH * $ratio1 * 1% / 1vh;
			top: $exteT * $ratio1 * 1% / 1vh;
			// height: 400vh;
			// top: -500vh;
			.bg_c3 {
				height: 100vh * 100% / $exteH;
				// height: 100vh;
			}
		}
		#exterior-text {
			height: $extetH * $ratio1 * 1% / 1vh;
			top: $extetT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -650vh;
			.sticky-wrapper {
				height: 100vh * 100% / $extetH;
				// height: 100vh;
			}
		}
		#technology {
			height: $techH * $ratio1 * 1% / 1vh;
			top: $techT * $ratio1 * 1% / 1vh;
			// height: 400vh;
			// top: -500vh;
			.bg_c4 {
				height: 100vh * 100% / $techH;
				// height: 100vh;
			}
		}
		#technology-text {
			height: $techtH * $ratio1 * 1% / 1vh;
			top: $techtT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -650vh;
			.sticky-wrapper {
				height: 100vh * 100% / $techtH;
				// height: 100vh;
			}
		}
		#performance {
			height: $perfH * $ratio1 * 1% / 1vh;
			top: $perfT * $ratio1 * 1% / 1vh;
			// height: 400vh;
			// top: -500vh;
			.bg_c5 {
				height: 100vh * 100% / $perfH;
				// height: 100vh;
			}
		}
		#performance-text {
			height: $perftH * $ratio1 * 1% / 1vh;
			top: $perftT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -650vh;
			.sticky-wrapper {
				height: 100vh * 100% / $perftH;
				// height: 100vh;
			}
		}
		#conception {
			height: $concepH * $ratio1 * 1% / 1vh;
			top: $concepT * $ratio1 * 1% / 1vh;
			// height: 350vh;
			// top: -750vh;
			.bg_c6 {
				height: 100vh * 100% / $concepH;
				// height: 100vh;
			}
		}
		#conception-text {
			height: $conceptH * $ratio1 * 1% / 1vh;
			top: $conceptT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -900vh;
			.sticky-wrapper {
				height: 100vh * 100% / $conceptH;
				// height: 100vh;
			}
		}
		#imagination {
			height: $imgnH * $ratio1 * 1% / 1vh;
			top: $imgnT * $ratio1 * 1% / 1vh;
			// height: 350vh;
			// top: -1000vh;
			.sticky-wrapper {
				height: 100vh * 100% / $imgnH;
				// height: 100vh;
			}
		}
		#imagination_title {
			height: $imgntH * $ratio1 * 1% / 1vh;
			top: $imgntT * $ratio1 * 1% / 1vh;
			// height: 150vh;
			// top: -1150vh;
			.sticky-wrapper {
				height: 100vh * 100% / $imgntH;
				// height: 100vh;
			}
		}
		#display {
			height: $displayH1 * $ratio1 * 1% / 1vh;
			top: $displayT * $ratio1 * 1% / 1vh;
			// height: 250vh;
			// top: -1150vh;
			.img-wrapper {
				height: 100vh * 100% / $displayH1;
				// height: 100vh;
			}
			.series_display {
				height: 150vh * 100% / $displayH1;
				top: -100vh * 100% / $displayH1;
				// height: 150vh;
				// top: -100vh;
				.sticky-wrapper {
					height: 100vh * 100% / $seridispH;
					// height: 100vh;
				}
			}
			.form-mask {
				height: 100vh * 100% / $displayH1;
				top: 151vh * 100% / $displayH1;
				// height: 100vh;
				// top: 150vh;
			}
			.reservation {
				height: 100vh * 100% / $displayH1;
				top: -100vh * 100% / $displayH1;
				// height: 100vh;
				// top: -100vh;
				.reservation-form {
					height: auto;
					max-height: 90%;
				}
			}
		}
	}
}

.apiLoadingFrame {
	display: none;
	position: fixed;
	width: 100%;
	height: 100vh;
	left: 0;
	top: 0;
	background-color: rgba(#111, 0.99);
	opacity: 0;
	transition: 1s;
}

.loading-indicator {
	display: none;
	position: fixed;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: 1s;
	.loading-ring {
		position: fixed;
		width: 60px;
		height: 60px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		border-radius: 50%;
		background-image: linear-gradient(
			90deg,
			rgba(142, 54, 54, 1) 33%,
			rgba(53, 73, 137, 1) 67%
		);
		background-size: 100px 100px;
		animation: OuterRotate $time2 infinite linear forwards;
		.inner-ring {
			position: absolute;
			width: 52px;
			height: 52px;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			background-color: rgba(#111, 1);
			border-radius: 50%;
		}
	}
	.t-ring {
		position: fixed;
		width: 65px;
		height: 65px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		border-radius: 50%;
		.bar {
			position: absolute;
			width: 15px;
			height: 35px;
			left: 50%;
			bottom: 50%;
			transform: translate(-50%, 0);
			background-color: rgba(#111, 1);
			&.bar1 {
				transform-origin: center bottom;
				animation: InnerRotate1 $time1 infinite ease forwards;
			}
			&.bar2 {
				transform: translate(-50%, 0) rotate(72deg);
				transform-origin: center bottom;
				animation: InnerRotate2 $time1 infinite ease forwards;
			}
			&.bar3 {
				transform: translate(-50%, 0) rotate(144deg);
				transform-origin: center bottom;
				animation: InnerRotate3 $time1 infinite ease forwards;
			}
			&.bar4 {
				transform: translate(-50%, 0) rotate(216deg);
				transform-origin: center bottom;
				animation: InnerRotate4 $time1 infinite ease forwards;
			}
			&.bar5 {
				transform: translate(-50%, 0) rotate(288deg);
				transform-origin: center bottom;
				animation: InnerRotate5 $time1 infinite ease forwards;
			}
		}
	}
}

.content {
	position: fixed;
	width: 100vw;
	height: 100%;
	top: 0;
	right: 0;
	z-index: 600;
	.content-body {
		position: absolute;
		width: 33vw;
		height: 100%;
		top: 0;
		left: 67vw;
		// background-color: rgba(#111, 0.8);
		// backdrop-filter: blur(10.3px);
		// -webkit-backdrop-filter: blur(10.3px);
		z-index: 5;
		.content-btn {
			position: absolute;
			width: 24px;
			height: 40px;
			right: calc(3.8vw + 17.4px);
			top: calc(2.6vw + 9.8px);
			z-index: 10;
			cursor: pointer;
			user-select: none;
			.longbar {
				position: absolute;
				width: 24px;
				height: 2px;
				top: 50%;
				background-color: #fff;
				transform: translateY(50%) rotate(20deg);
			}
			.shortbar {
				position: absolute;
				width: 24px;
				height: 2px;
				top: 50%;
				background-color: #fff;
				transform: translateY(50%) rotate(-20deg);
			}
		}
		.content-title {
			position: relative;
			top: 40%;
			left: 17.5%;
			p {
				position: absolute;
				top: 0;
				transition: opacity 0.5s ease;
				span {
					position: relative;
					display: inline-block;
					font-size: 2.4rem;
					line-height: 1.92;
					letter-spacing: 1.8px;
					font-family: "BMWTypeNextLatinTT-Bold",
						arudjingxiheipe1xg30_hv, 微軟正黑體, serif;
					&::after {
						content: "";
						position: absolute;
						display: block;
						width: 100%;
						height: 3px;
						left: 0px;
						bottom: -3px;
						background-image: url("~@/assets/color-bar.png");
						background-repeat: repeat-x;
						background-position: 0 0;
						animation: color-bar-loop 2.5s linear infinite forwards;
						background-size: 400px 6px;
					}
				}
			}
		}
		.content-text {
			position: relative;
			top: 48.52%;
			left: 18%;
			width: 100%;
			p {
				position: absolute;
				top: 0;
				transition: opacity 0.5s ease;
				width: 100%;
				span {
					display: inline-block;
					width: 75%;
					font-size: 1.7rem;
					line-height: 2.12;
					letter-spacing: 1.28px;
					font-family: "BMWTypeNextLatinTT-Thin",
						arudjingxiheipe1xg30_md, 微軟正黑體, serif;
				}
			}
		}
		.content-switcher {
			position: relative;
			top: 68%;
			left: calc(17.5% - 8px);
			.switcher_left,
			.switcher_right {
				display: inline-block;
				width: 75px;
				height: 75px;
				border: solid 0.5px rgba(#fff, 0.15);
				border-radius: 50%;
				margin: 0 8px;
				background-size: 24% auto;
				background-position: center center;
				background-repeat: no-repeat;
				cursor: pointer;
				user-select: none;
			}
			.switcher_left {
				background-image: url("~@/assets/arrow_left.png");
			}
			.switcher_right {
				background-image: url("~@/assets/arrow_right.png");
			}
		}
		.content-indicator {
			position: absolute;
			bottom: calc(5.5% + 76px);
			right: 4.7vw;
			p {
				position: relative;
				display: inline-block;
				font-size: 1.5rem;
				letter-spacing: 1.13px;
				text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
				color: rgba(#fff, 0.45);
				-webkit-writing-mode: vertical-rl;
				writing-mode: vertical-lr;
				transition: opacity 0.5s ease;
				span {
					position: absolute;
					margin-top: 55px;
					font-size: inherit;
					color: inherit;
					transition: opacity 0.5s ease;
					&::before {
						content: "";
						position: absolute;
						display: block;
						width: 1px;
						height: 50px;
						left: 50%;
						top: -50px;
						transform: translateX(-50%);
						background-image: linear-gradient(
							to top,
							transparent 2%,
							rgba(#fff, 0.45) 98%
						);
						background-size: cover;
						background-repeat: no-repeat;
						transition: opacity 0.5s ease;
					}
				}
			}
		}
	}
	.content-bg {
		position: absolute;
		width: 67vw;
		height: 100%;
		top: 0;
		left: 0;
		z-index: 10;
		img {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	.content-mask {
		position: absolute;
		width: 100vw;
		height: 100%;
		top: 0;
		left: 0;
		z-index: 1;
		img {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
	opacity: 1;
}

.bg-switch-enter-active,
.bg-switch-leave-active {
	transition: opacity 0.5s ease;
}
.bg-switch-enter-from,
.bg-switch-leave-to {
	opacity: 0;
}
.bg-switch-enter-to,
.bg-switch-leave-from {
	opacity: 1;
}

@media screen and (max-width: 992px) {
	#app {
		main {
			.site-sticky {
				.sticky-wrapper {
					.goto-button {
						.gotoForm-button,
						.gotoEquipment-button {
							width: 27px;
							height: 115.5px;
							background-size: 46px auto;
							.border {
								&.top,
								&.bottom {
									width: 27px;
								}
								&.right {
									height: 115.5px;
								}
							}
						}
						.gotoForm-button {
							background-image: url("~@/assets/menu_button1_mobile.png");
						}
						.gotoEquipment-button {
							background-image: url("~@/assets/menu_button2_mobile.png");
						}
					}
				}
			}
		}
	}

	.content {
		.content-body {
			width: 100%;
			height: 36%;
			top: auto;
			bottom: 0;
			left: 0;
			z-index: 20;
			.content-btn {
				position: fixed;
				// top: calc(-64 / 36 * 100% + 30px);
			}
			.content-title {
				top: 8.7%;
				left: 7.5%;
			}
			.content-text {
				top: 27%;
				left: 8%;
				p {
					span {
						width: 84%;
					}
					.pc_break {
						display: none;
					}
				}
			}
			.content-switcher {
				position: absolute;
				top: auto;
				bottom: 10%;
				left: calc(7.5% - 8px);
			}
			.content-indicator {
				display: none;
			}
		}
		.content-bg {
			width: 100%;
			height: 64%;
		}
		.content-mask {
			img {
				object-position: center 65%;
			}
		}
	}
}
@media screen and (max-width: 768px) {
	.content {
		.content-body {
			.content-btn {
				.longbar,
				.shortbar {
					height: 1px;
				}
			}
			.content-title {
				p {
					span {
						text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.16);
						font-size: 1.4rem;
						line-height: 2.57;
						letter-spacing: 0.7px;
						&::after {
							height: 2px;
						}
					}
				}
			}
			.content-text {
				p {
					span {
						width: 84%;
						font-size: 1.2rem;
						line-height: 1.75;
						letter-spacing: 0.72px;
					}
					.pc_break {
						display: none;
					}
				}
			}
			.content-switcher {
				left: calc(7.5% - 6px);
				.switcher_left,
				.switcher_right {
					width: 54px;
					height: 54px;
					margin: 6px;
				}
			}
		}
	}
}
@media screen and (max-height: 600px) {
	.content {
		.content-body {
			width: 100%;
			height: 45%;
			.content-btn {
				top: calc(-55 / 45 * 100% + 30px);
			}
			.content-title {
				top: 3%;
			}
			.content-text {
				top: 25%;
			}
			.content-switcher {
				bottom: 5%;
			}
		}
		.content-bg {
			height: 55%;
		}
	}
}

@keyframes shine {
	0% {
		background-position: 0vw 10px;
	}
	// 90%
	// 	background-position: 73vw
	100% {
		background-position: 100vw 10px;
	}
}

@keyframes shake {
	0% {
		transform: translateY(0px);
	}
	10% {
		transform: translateY(-5px);
	}
	20% {
		transform: translateY(0px);
	}
	30% {
		transform: translateY(-5px);
	}
	40% {
		transform: translateY(0px);
	}
	100% {
		transform: translateY(0px);
	}
}

@keyframes hShake_right {
	0% {
		transform: translateX(0px);
	}
	10% {
		transform: translateX(3px);
	}
	20% {
		transform: translateX(0px);
	}
	30% {
		transform: translateX(3px);
	}
	40% {
		transform: translateX(0px);
	}
	100% {
		transform: translateX(0px);
	}
}

@keyframes hShake_right_sm {
	0% {
		transform: translate(0px, -50%);
	}
	60% {
		transform: translate(0px, -50%);
	}
	70% {
		transform: translate(2px, -50%);
	}
	80% {
		transform: translate(0px, -50%);
	}
	90% {
		transform: translate(2px, -50%);
	}
	100% {
		transform: translate(0px, -50%);
	}
}

@keyframes hShake_left {
	0% {
		transform: translateX(0px);
	}
	10% {
		transform: translateX(-3px);
	}
	20% {
		transform: translateX(0px);
	}
	30% {
		transform: translateX(-3px);
	}
	40% {
		transform: translateX(0px);
	}
	100% {
		transform: translateX(0px);
	}
}

@keyframes nav_anim {
	0% {
		transform: scale(1);
	}
	60% {
		transform: scale(1);
	}
	70% {
		// transform: scale(1);
	}
	80% {
		transform: scale(0.8);
	}
	90% {
		// transform: scale(0.6);
	}
	100% {
		transform: scale(1);
	}
}

@keyframes OuterRotate {
	0% {
		transform: translate(-50%, -50%) rotate(0deg);
		// background-position: 0 0
	}
	50% {
		transform: translate(-50%, -50%) rotate(180deg);
		// background-position: 50px 50px
	}
	100% {
		transform: translate(-50%, -50%) rotate(360deg);
		// background-position: 100px 100px
	}
}
@keyframes InnerRotate1 {
	0% {
		transform: translate(-50%, 0%) rotate(0deg);
	}
	50% {
		transform: translate(-50%, 0%) rotate(180deg);
	}
	100% {
		transform: translate(-50%, 0%) rotate(360deg);
	}
}

@keyframes InnerRotate2 {
	0% {
		transform: translate(-50%, 0%) rotate(72deg);
	}
	50% {
		transform: translate(-50%, 0%) rotate(252deg);
	}
	100% {
		transform: translate(-50%, 0%) rotate(432deg);
	}
}

@keyframes InnerRotate3 {
	0% {
		transform: translate(-50%, 0%) rotate(144deg);
	}
	50% {
		transform: translate(-50%, 0%) rotate(324deg);
	}
	100% {
		transform: translate(-50%, 0%) rotate(504deg);
	}
}

@keyframes InnerRotate4 {
	0% {
		transform: translate(-50%, 0%) rotate(216deg);
	}
	50% {
		transform: translate(-50%, 0%) rotate(396deg);
	}
	100% {
		transform: translate(-50%, 0%) rotate(576deg);
	}
}

@keyframes InnerRotate5 {
	0% {
		transform: translate(-50%, 0%) rotate(288deg);
	}
	50% {
		transform: translate(-50%, 0%) rotate(468deg);
	}
	100% {
		transform: translate(-50%, 0%) rotate(648deg);
	}
}

@media screen and (max-width: 1680px) {
	html {
		font-size: 9px;
	}
}

@media screen and (max-width: 1440px) {
	html {
		font-size: 8.5px;
	}
}

@media screen and (max-width: 1200px) {
	html {
		font-size: 8px;
	}
}
@media screen and (max-width: 768px) {
	html {
		font-size: 10px;
	}
	body {
		#app {
			width: 100%;
			height: 100%;
			main {
				height: $mainH2 * 1% / 1vh;
				.site-sticky {
					.sticky-wrapper {
						height: $ssH * $ratio2 * 1% / 1vh;
					}
				}
				#story {
					height: $storyH * $ratio2 * 1% / 1vh;
				}
				#title {
					height: $titleH * $ratio2 * 1% / 1vh;
					top: $titleT * $ratio2 * 1% / 1vh;
				}
				#description {
					height: $descH * $ratio2 * 1% / 1vh;
					top: $descT * $ratio2 * 1% / 1vh;
				}
				#description-text {
					height: $desctH * $ratio2 * 1% / 1vh;
					top: $desctT * $ratio2 * 1% / 1vh;
				}
				#exterior {
					height: $exteH * $ratio2 * 1% / 1vh;
					top: $exteT * $ratio2 * 1% / 1vh;
				}
				#exterior-text {
					height: $extetH * $ratio2 * 1% / 1vh;
					top: $extetT * $ratio2 * 1% / 1vh;
				}
				#technology {
					height: $techH * $ratio2 * 1% / 1vh;
					top: $techT * $ratio2 * 1% / 1vh;
				}
				#technology-text {
					height: $techtH * $ratio2 * 1% / 1vh;
					top: $techtT * $ratio2 * 1% / 1vh;
				}
				#performance {
					height: $perfH * $ratio2 * 1% / 1vh;
					top: $perfT * $ratio2 * 1% / 1vh;
				}
				#performance-text {
					height: $perftH * $ratio2 * 1% / 1vh;
					top: $perftT * $ratio2 * 1% / 1vh;
				}
				#conception {
					height: $concepH * $ratio2 * 1% / 1vh;
					top: $concepT * $ratio2 * 1% / 1vh;
				}
				#conception-text {
					height: $conceptH * $ratio2 * 1% / 1vh;
					top: $conceptT * $ratio2 * 1% / 1vh;
				}
				#imagination {
					height: $imgnH * $ratio2 * 1% / 1vh;
					top: $imgnT * $ratio2 * 1% / 1vh;
				}
				#imagination_title {
					height: $imgntH * $ratio2 * 1% / 1vh;
					top: $imgntT * $ratio2 * 1% / 1vh;
				}
				#display {
					height: $displayH2 * $ratio2 * 1% / 1vh;
					top: $displayT * $ratio2 * 1% / 1vh;
					.img-wrapper {
						height: 100vh * 100% / $displayH2;
					}
					.series_display {
						height: 150vh * 100% / $displayH2;
						top: -100vh * 100% / $displayH2;
					}
					.form-mask {
						height: (100vh + $rwdHeight1) * 100% / $displayH2;
						top: 151vh * 100% / $displayH2;
						// height: 180vh
					}
					.reservation {
						height: (100vh + $rwdHeight1) * 100% / $displayH2;
						top: -100vh * 100% / $displayH2;
						// height: 180vh;
					}
				}
			}
		}
	}
}
@media screen and (max-height: 800px) {
	body {
		#app {
			width: 100%;
			height: 100%;
			main {
				height: $mainH3 * 1% / 1vh;
				.site-sticky {
					.sticky-wrapper {
						height: $ssH * $ratio3 * 1% / 1vh;
					}
				}
				#story {
					height: $storyH * $ratio3 * 1% / 1vh;
				}
				#title {
					height: $titleH * $ratio3 * 1% / 1vh;
					top: $titleT * $ratio3 * 1% / 1vh;
				}
				#description {
					height: $descH * $ratio3 * 1% / 1vh;
					top: $descT * $ratio3 * 1% / 1vh;
				}
				#description-text {
					height: $desctH * $ratio3 * 1% / 1vh;
					top: $desctT * $ratio3 * 1% / 1vh;
				}
				#exterior {
					height: $exteH * $ratio3 * 1% / 1vh;
					top: $exteT * $ratio3 * 1% / 1vh;
				}
				#exterior-text {
					height: $extetH * $ratio3 * 1% / 1vh;
					top: $extetT * $ratio3 * 1% / 1vh;
				}
				#technology {
					height: $techH * $ratio3 * 1% / 1vh;
					top: $techT * $ratio3 * 1% / 1vh;
				}
				#technology-text {
					height: $techtH * $ratio3 * 1% / 1vh;
					top: $techtT * $ratio3 * 1% / 1vh;
				}
				#performance {
					height: $perfH * $ratio3 * 1% / 1vh;
					top: $perfT * $ratio3 * 1% / 1vh;
				}
				#performance-text {
					height: $perftH * $ratio3 * 1% / 1vh;
					top: $perftT * $ratio3 * 1% / 1vh;
				}
				#conception {
					height: $concepH * $ratio3 * 1% / 1vh;
					top: $concepT * $ratio3 * 1% / 1vh;
				}
				#conception-text {
					height: $conceptH * $ratio3 * 1% / 1vh;
					top: $conceptT * $ratio3 * 1% / 1vh;
				}
				#imagination {
					height: $imgnH * $ratio3 * 1% / 1vh;
					top: $imgnT * $ratio3 * 1% / 1vh;
				}
				#imagination_title {
					height: $imgntH * $ratio3 * 1% / 1vh;
					top: $imgntT * $ratio3 * 1% / 1vh;
				}
				#display {
					height: $displayH3 * $ratio3 * 1% / 1vh;
					top: $displayT * $ratio3 * 1% / 1vh;
					.img-wrapper {
						height: 100vh * 100% / $displayH3;
					}
					.series_display {
						height: 150vh * 100% / $displayH3;
						top: -100vh * 100% / $displayH3;
					}
					.form-mask {
						height: (100vh + $rwdHeight2) * 100% / $displayH3;
						top: 151vh * 100% / $displayH3;
						// height: 170vh
					}
					.reservation {
						height: (100vh + $rwdHeight2) * 100% / $displayH3;
						top: -100vh * 100% / $displayH3;
						// height: 170vh;
					}
				}
			}
		}
	}
	@media screen and (max-width: 768px) {
		body {
			#app {
				width: 100%;
				height: 100%;
				main {
					height: $mainH4 * 1% / 1vh;
					.site-sticky {
						.sticky-wrapper {
							height: $ssH * $ratio4 * 1% / 1vh;
						}
					}
					#story {
						height: $storyH * $ratio4 * 1% / 1vh;
					}
					#title {
						height: $titleH * $ratio4 * 1% / 1vh;
						top: $titleT * $ratio4 * 1% / 1vh;
					}
					#description {
						height: $descH * $ratio4 * 1% / 1vh;
						top: $descT * $ratio4 * 1% / 1vh;
					}
					#description-text {
						height: $desctH * $ratio4 * 1% / 1vh;
						top: $desctT * $ratio4 * 1% / 1vh;
					}
					#exterior {
						height: $exteH * $ratio4 * 1% / 1vh;
						top: $exteT * $ratio4 * 1% / 1vh;
					}
					#exterior-text {
						height: $extetH * $ratio4 * 1% / 1vh;
						top: $extetT * $ratio4 * 1% / 1vh;
					}
					#technology {
						height: $techH * $ratio4 * 1% / 1vh;
						top: $techT * $ratio4 * 1% / 1vh;
					}
					#technology-text {
						height: $techtH * $ratio4 * 1% / 1vh;
						top: $techtT * $ratio4 * 1% / 1vh;
					}
					#performance {
						height: $perfH * $ratio4 * 1% / 1vh;
						top: $perfT * $ratio4 * 1% / 1vh;
					}
					#performance-text {
						height: $perftH * $ratio4 * 1% / 1vh;
						top: $perftT * $ratio4 * 1% / 1vh;
					}
					#conception {
						height: $concepH * $ratio4 * 1% / 1vh;
						top: $concepT * $ratio4 * 1% / 1vh;
					}
					#conception-text {
						height: $conceptH * $ratio4 * 1% / 1vh;
						top: $conceptT * $ratio4 * 1% / 1vh;
					}
					#imagination {
						height: $imgnH * $ratio4 * 1% / 1vh;
						top: $imgnT * $ratio4 * 1% / 1vh;
					}
					#imagination_title {
						height: $imgntH * $ratio4 * 1% / 1vh;
						top: $imgntT * $ratio4 * 1% / 1vh;
					}
					#display {
						height: $displayH4 * $ratio4 * 1% / 1vh;
						top: $displayT * $ratio4 * 1% / 1vh;
						.img-wrapper {
							height: 100vh * 100% / $displayH4;
						}
						.series_display {
							height: 150vh * 100% / $displayH4;
							top: -100vh * 100% / $displayH4;
						}
						.form-mask {
							height: (100vh + $rwdHeight3) * 100% / $displayH4;
							top: 151vh * 100% / $displayH4;
							// height: 230vh
						}
						.reservation {
							height: (100vh + $rwdHeight3) * 100% / $displayH4;
							top: -100vh * 100% / $displayH4;
							// height: 230vh;
						}
					}
				}
			}
		}
	}
}
</style>
